import * as types from './mutation-types'
import {BASE_URL} from "@/services/api";

export const loadIntervals = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/intervals/collection', data).then((response) => {
            commit(types.ADD_INTERVALS, response.data.interval)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateInterval = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.put('interval/' + data.interval, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const createInterval = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/interval', data).then((response) => {
            commit(types.ADD_INTERVAL, response.data.interval)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const showInterval = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('interval/' + id).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteInterval = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('interval/' + id).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

